import { render, staticRenderFns } from "./ch-reference-thankyou.vue?vue&type=template&id=6aabd421&scoped=true"
import script from "./ch-reference-thankyou.vue?vue&type=script&lang=js"
export * from "./ch-reference-thankyou.vue?vue&type=script&lang=js"
import style0 from "./ch-reference-thankyou.vue?vue&type=style&index=0&id=6aabd421&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aabd421",
  null
  
)

export default component.exports